import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import BrandMark from "@/components/BrandMark";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (user) {
    const dest = user.role === "trainer" ? "/app" : `/app/clients/${user.id}`;
    return <Navigate to={location.state?.from?.pathname || dest} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      // user state updates via context; navigate on next render via Navigate above
      const dest = r?.user?.role === "trainer" ? "/app" : "/app";
      navigate(dest);
    } else {
      setErr(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden">
        <img src="https://images.pexels.com/photos/18112392/pexels-photo-18112392.jpeg" alt="" className="w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-tr from-black via-black/60 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <div className="text-[10px] tracking-[0.4em] text-[#FF3B30] uppercase mb-3">/ Client Portal</div>
          <h2 className="font-display text-6xl uppercase leading-none">Meet me<br/>at the bar.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-sm">
          <Link to="/" className="block mb-12" data-testid="login-logo">
            <BrandMark size="md" />
          </Link>
          <div className="text-[10px] tracking-[0.4em] text-[#FF3B30] uppercase mb-3">/ Sign in</div>
          <h1 className="font-display text-5xl uppercase mb-10 leading-none">Access<br/>your plan</h1>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 block mb-2">Email</label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-none bg-black border-zinc-800 focus:border-[#FF3B30] text-white h-12" />
            </div>
            <div>
              <label className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 block mb-2">Password</label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-none bg-black border-zinc-800 focus:border-[#FF3B30] text-white h-12" />
            </div>
            {err && <div data-testid="login-error" className="text-sm text-red-400 border border-red-900 bg-red-950/30 p-3">{err}</div>}
            <Button data-testid="login-submit" type="submit" disabled={loading} className="rounded-none bg-[#FF3B30] hover:bg-[#D63028] text-white uppercase tracking-[0.2em] h-12 w-full text-xs">
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
          <Link to="/" className="block mt-10 text-xs uppercase tracking-[0.3em] text-zinc-500 hover:text-white transition">← Back to site</Link>
        </div>
      </div>
    </div>
  );
}
